module.exports = __webpack_public_path__ + "img/freelancer.e0942492.jpg";